<!-- Header -->
<poke-header></poke-header>

<main>

  <ng-template [ngIf]="isLoading">
    <section class="pokemon__names">
      <h1 class="slideInLeft">{{pokemon[0].name}}</h1>
      <h2 class="slideInRight">{{pokemon[1].names[0].name}}</h2>
    </section>

    <section class="pokemon__status">
      <img
        [src]="pokemon[0].sprites.other.dream_world.front_default"
        [alt]="pokemon[0].name"
        class="slideInDown"
      >

      <article class="pokemon__status__statistics fadeIn">
        <section>
          <h3>Estatísticas</h3>

          <ol>
            <li *ngFor="let value of pokemon[0].stats">
                {{ value.stat.name }}

              <strong>
                {{ value.base_stat }}
              </strong>
            </li>
          </ol>
        </section>

        <a [routerLink]="['']" class="btn btn__secondary">
          Voltar
        </a>
      </article>
    </section>
  </ng-template>

  <img
    src="assets/error.png"
    alt="Deu erro na mostragem do pokemon"
    width="100%"
    *ngIf="apiError"
  >
</main>
